import { useMemo } from 'react'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { InsightCount } from 'schemas/action/InsightCountSchema'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import { WidgetId } from 'features/types'
import { DashboardWidget } from 'features/widget/types'

import { DayAndHourWidgetsType, TransformedDataSet } from '../types'
import { getDataLabel } from './utils'

const getDayAndHourData = (
  widgetSetting: DayAndHourWidgetsType,
  widgetData: DashboardWidget<InsightCount>
) => {
  const { viewOption } = widgetSetting

  const {
    set: dataSet,
    status,
    extraInfo
  } = widgetData.data![0]!.results![0]!.data!.insights![0]!.dataset![0]

  let total = 0
  const transformedDataSet = dataSet?.reduce<TransformedDataSet[]>((acc, cur) => {
    if (cur.name === 'All.All') {
      total = cur.value!
    } else if (total !== 0) {
      acc.push({
        ...cur,
        share: (cur.value! / total) * 100,
        label: getDataLabel(cur.name!, viewOption!)
      })
    }
    return acc
  }, [])

  return {
    status,
    extraInfo,
    dataSet: transformedDataSet,
    isEmpty: transformedDataSet?.length === 0
  }
}

const useDayAndHourData = (widgetId: WidgetId) => {
  const widgetSetting = useDashboardWidgetSetting<DayAndHourWidgetsType>(widgetId)
  const widgetData = useDashboardWidgetData<InsightCount>(widgetId)

  const dayAndHourData = useMemo(() => getDayAndHourData(widgetSetting, widgetData), [
    widgetSetting,
    widgetData
  ])
  return dayAndHourData
}

export default useDayAndHourData
